import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { MapPin, Navigation } from 'lucide-react';

const LocationMap = () => {
  const { t } = useLang();

  return (
    <section id="location" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-[13px] uppercase tracking-[0.2em] text-brand-primary font-bold mb-3">
            {t.location.kicker}
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6">
            {t.location.title}
          </h3>
          <p className="text-lg text-slate-600">
            {t.location.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10">
          {/* Gastonia Campus */}
          <div className="bg-slate-50 rounded-3xl p-6 border border-slate-200">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-2xl bg-brand-secondary flex items-center justify-center shrink-0">
                <MapPin className="w-6 h-6 text-brand-primary" />
              </div>
              <div>
                <h4 className="text-2xl font-bold text-slate-900 mb-2">{t.location.gastoniaTitle}</h4>
                <p className="text-slate-600">{t.location.gastoniaDesc}</p>
                <a 
                  href="https://maps.google.com/?q=2020+Remount+Rd,+Suite+D-101,+Gastonia,+NC+28054" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-brand-primary font-semibold hover:text-blue-800 transition-colors"
                >
                  <Navigation className="w-4 h-4" />
                  {t.location.directions}
                </a>
              </div>
            </div>
            <div className="w-full h-80 rounded-2xl overflow-hidden border border-slate-200">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3257.659695431613!2d-81.1444158!3d35.2639722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885698b67ebc1a7d%3A0xc33d6b052d9a690d!2s2020%20Remount%20Rd%20%23101%2C%20Gastonia%2C%20NC%2028054!5e0!3m2!1sen!2sus!4v1718645000000!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Gastonia Campus Map"
              ></iframe>
            </div>
          </div>

          {/* Lake Norman Campus */}
          <div className="bg-slate-50 rounded-3xl p-6 border border-slate-200">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-2xl bg-brand-secondary flex items-center justify-center shrink-0">
                <MapPin className="w-6 h-6 text-brand-primary" />
              </div>
              <div>
                <h4 className="text-2xl font-bold text-slate-900 mb-2">{t.location.lakeNormanTitle}</h4>
                <p className="text-slate-600">{t.location.lakeNormanDesc}</p>
                <a 
                  href="https://maps.google.com/?q=500+S+Main+St,+Suite+113,+Mooresville,+NC+28115" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-brand-primary font-semibold hover:text-blue-800 transition-colors"
                >
                  <Navigation className="w-4 h-4" />
                  {t.location.directions}
                </a>
              </div>
            </div>
            <div className="w-full h-80 rounded-2xl overflow-hidden border border-slate-200">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.134255146591!2d-80.816666!3d35.580797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88540b6e9a7e3d17%3A0xc6fb657494a86f9e!2s500%20S%20Main%20St%20%23113%2C%20Mooresville%2C%20NC%2028115!5e0!3m2!1sen!2sus!4v1718645000000!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Lake Norman Campus Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
